export enum ResourceName {
  KeyNote = 'Keynote',
  PdfDocument = 'PDF',
  WordDocument = 'Word',
  Video = 'Video',
  Audio = 'MP3',
  Images = 'Image',
  WebPage = 'Link',
  HTML5 = 'HTML',
  YoutubeVideos = 'Youtube',
  VimeoVideos = 'Vimeo',
  Spreadsheet = 'XLS',
  Presentation = 'PPT',
  Slides = 'PPT',
  PhotoAlbum = 'Photo'
}
